 'use client';
import { Placeholder, Card, Form } from "react-bootstrap";

const ArticlePlaceholder = () => {
  return (
    <div className="page-container loading-placeholder d-flex flex-column flex-lg-row gap-4">
      <div className="flex-grow-1">
        <Placeholder as="p" animation="glow">
          <Placeholder xs={3} /> <Placeholder xs={2} /> <Placeholder xs={2} />
        </Placeholder>
        <Placeholder as="h1" animation="glow">
          <Placeholder xs={9} />
        </Placeholder>

        <div className="mb-4">
          <Placeholder as="p" animation="glow">
            <Placeholder xs={12} />
            <Placeholder xs={10} /> <Placeholder xs={9} />
          </Placeholder>
        </div>

        <div className="mb-4">
          <Placeholder as="h5" animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={11} />
            <Placeholder xs={10} /> <Placeholder xs={8} />
          </Placeholder>
        </div>

        <div className="mb-4">
          <Placeholder as="p" animation="glow">
            <Placeholder xs={12} />
            <Placeholder xs={10} /> <Placeholder xs={9} />
          </Placeholder>
        </div>

        {/* Social Icons Placeholder */}
        <div className="d-flex gap-3 mb-5">
          {[...Array(3)].map((_, idx) => (
            <Placeholder key={idx} as="div" animation="glow" className="rounded-circle" style={{ width: 32, height: 32 }} />
          ))}
        </div>

        {/* Comment Form Placeholder */}
        <Card className="p-3">
          <Placeholder as="h5" animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
          <Form>
            <Placeholder animation="glow">
              <Placeholder xs={6} className="mb-2" />
              <Placeholder xs={6} className="mb-2" />
              <Placeholder xs={12} className="mb-2" style={{ height: "100px" }} />
              <Placeholder variant="primary" xs={2} />
            </Placeholder>
          </Form>
        </Card>
      </div>

      {/* Sidebar */}
      <div className="sidebar" style={{ minWidth: "300px" }}>
        <Card className="mb-4 p-3">
          <Placeholder as="h5" animation="glow">
            <Placeholder xs={8} />
          </Placeholder>
          <Placeholder animation="glow">
            <Placeholder xs={10} />
          </Placeholder>
        </Card>

        <Card className="mb-4 p-3" style={{ height: 150 }}>
          <Placeholder animation="glow">
            <Placeholder xs={12} style={{ height: "100%" }} />
          </Placeholder>
        </Card>

        <Card className="p-3">
          <Placeholder as="h5" animation="glow">
            <Placeholder xs={7} />
          </Placeholder>
          <Placeholder animation="glow">
            <Placeholder xs={12} className="mb-2" />
            <Placeholder xs={8} />
          </Placeholder>
        </Card>
      </div>
    </div>
  );
};

export default ArticlePlaceholder;
